import './QualitativeObjectiveManagement.css';

import React, { useState } from 'react';
import QualitativeObjectivesTable from './QualitativeObjectivesTable';
import { useContentContext } from '../../../layout/Layout';
import { CommonInfo } from '../quant/QuantitativeObjectiveManagement';
import { findAvailableDateRange, getDisabledDateRanges } from '../../components/helper';
import { showNotification } from '../../../b2b-common/Notification';
import QualitativeObjectiveEditForm from '../../components/objectives/QualitativeObjectiveEditForm';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const QualitativeObjectiveManagement = ({ areaIndicator, onRefresh = null }) => {
    const { t } = useB2BTranslation('b2b-plans');
    const { setNotification } = useContentContext();
    const [showObjectiveEditForm, setShowObjectiveEditForm] = useState(false);

    const areaStartDate = areaIndicator.area.areaStartDate;
    const areaEndDate = areaIndicator.area.areaEndDate;
    const disabledDateRanges = getDisabledDateRanges(areaIndicator);
    const availableDates = findAvailableDateRange(areaStartDate, areaEndDate, disabledDateRanges);

    const [objectiveSelected, setObjectiveSelected] = useState(null);

    const handleObjectiveClick = (objective) => {
        setObjectiveSelected(objective);
        setShowObjectiveEditForm(true);
    };

    const handleSavedQuantitativeObjective = (objective) => {
        showNotification(setNotification, t('Objective created or updated'), 'success', 3000);
        setShowObjectiveEditForm(false);
        onRefresh && onRefresh();
    };

    const handleDeletedQuantitativeObjective = (objective) => {
        showNotification(setNotification, t('Objective deleted'), 'success', 3000);
        setShowObjectiveEditForm(false);
        onRefresh && onRefresh();
    };

    const handleNewObjective = () => {
        if (availableDates) {
            setObjectiveSelected(null);
            setShowObjectiveEditForm(true);
        } else {
            showNotification(setNotification, t('No available date range found'), 'warning', 3000);
        }
    };

    return (
        <>
            <CommonInfo areaIndicator={areaIndicator} />
            <QualitativeObjectivesTable
                areaIndicator={areaIndicator}
                onObjectiveClick={handleObjectiveClick}
                onNewObjective={handleNewObjective}
            />
            {
                showObjectiveEditForm &&
                <QualitativeObjectiveEditForm
                    objective={objectiveSelected}
                    planUUID={areaIndicator.area.plan.planUUID}
                    areaId={areaIndicator.area.areaId}
                    areaIndicatorId={areaIndicator.areaIndicatorId}
                    indicator={areaIndicator.indicatorDTO}
                    startDate={!objectiveSelected ? availableDates.availableStartDate : objectiveSelected.startDate}
                    endDate={!objectiveSelected ? availableDates.availableEndDate : objectiveSelected.endDate}
                    disabledDateRanges={getDisabledDateRanges(areaIndicator, objectiveSelected ? objectiveSelected.objectiveId : null)}
                    onSave={handleSavedQuantitativeObjective}
                    onDelete={handleDeletedQuantitativeObjective}
                    onCancel={() => setShowObjectiveEditForm(false)}
                />
            }
        </>
    );
};

export default QualitativeObjectiveManagement;